import { Box, Paper, Typography } from '@mui/material';
import { colors } from '@src/styles';
import { card, monoLabelSX, titleFontFamily } from '../utils/format';

const TONE: Record<string, string> = {
  ok: colors.status.concluded,
  bad: colors.status.rejected,
  warn: colors.status.pending,
};

export function KpiTile({
  label,
  value,
  sub,
  tone,
}: {
  label: string;
  value: string;
  sub?: string;
  tone?: 'ok' | 'bad' | 'warn';
}) {
  const accent = tone ? TONE[tone] : null;
  return (
    <Paper
      elevation={0}
      sx={{
        ...card,
        position: 'relative',
        overflow: 'hidden',
        minHeight: 112,
        display: 'flex',
        flexDirection: 'column',
        '&::before': accent
          ? {
              content: '""',
              position: 'absolute',
              inset: '0 0 auto 0',
              height: 2,
              background: `linear-gradient(90deg, ${accent}, transparent 70%)`,
              opacity: 0.8,
            }
          : undefined,
      }}
    >
      <Typography sx={monoLabelSX}>{label}</Typography>
      <Typography
        sx={{
          fontFamily: titleFontFamily,
          fontSize: { xs: '26px', md: '30px' },
          fontWeight: 500,
          letterSpacing: '-0.03em',
          lineHeight: 1.1,
          mt: 1,
          color: accent ?? colors.primary.white,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {value}
      </Typography>
      {sub && (
        <Typography sx={{ fontSize: '12px', color: colors.brand.textSecondary, mt: 'auto', pt: 1 }}>{sub}</Typography>
      )}
    </Paper>
  );
}

export function KpiRow({ children }: { children: React.ReactNode }) {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 2 }}>{children}</Box>
  );
}
